<template>
  <div class="information">
    <el-row :gutter="20" class="itemRow" style="margin-top: 10px">
      <el-col :span="12">
        <div class="item_text">
           <span class="item_icon">
                <img src="@/assets/teamIcon/icon1.png" alt="" />
            </span>
          <div class="textName color6">工队类型 : </div>
          <div class="item_data color3">{{ Detail.teamTypeName }}</div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="item_text">
          <span class="item_icon">
                <img src="@/assets/teamIcon/zhuanye.png" alt="" />
          </span>
          <span class="color6">工程专业 : </span>
          <!-- <span class="item_data color3">{{ Detail.category }}</span> -->
          <span class="item_data color3">{{ Detail.category | formattingEngineering}}</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="itemRow" style="margin-top: 10px">
      <el-col :span="12">
        <div class="item_text">
          <span class="item_icon">
                <img src="@/assets/teamIcon/icon3.png" alt="" />
          </span>
          <div class="textName color6">负责人 :</div>
          <div class="item_data color3">{{ Detail.contact }}</div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="item_text">
           <span class="item_icon">
                <img src="@/assets/teamIcon/icon4.png" alt="" />
            </span>
          <span class="color6">联系电话 : </span>
          <span class="item_data color3" v-if="showpNumber">{{
            Detail.phoneNumber
          }}
          </span>
          <span class="item_data color3" v-if="showpNumber==false">
            {{ ShowPhone(Detail.phoneNumber) }}
            <span style="color: #0286df" class="showText"  @click="ShowPhoneNumber">
              查看完整号码
            </span>
          </span>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="itemRow" style="margin-top: 10px">
      <el-col :span="12">
        <div class="item_text">
           <span class="item_icon">
                <img src="@/assets/teamIcon/icon5.png" alt="" />
            </span>
          <div class="langtextName color6">所属工程公司 :</div>
          <div class="item_data color3">{{ Detail.companyName ? Detail.companyName :"暂无"}}</div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="item_text">
          <span class="item_icon">
                <img src="@/assets/teamIcon/icon6.png" alt="" />
          </span>
          <span class="color6">所在地区 : </span>
          <span class="item_data color3">
            {{ Detail.provinceName ? Detail.provinceName : "" }}
            {{ Detail.cityName ? `- ${Detail.cityName}` : "" }}
            {{ Detail.areaName ? `- ${Detail.areaName}` : "" }}
            {{ Detail.address ? `- ${Detail.address}` : "" }}
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCanLookPhone: false,
      showpNumber: false
    }
  },
  props: {
    Detail: {
      type: Object
    }
  },

  methods: {
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.$_login({
          callBack: function() {
            this.$store.dispatch("setUser")
          }.bind(this)
        })
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.information {
  padding:20px 30px;
  .itemRow {
    font-size: 16px;
    color: #666666;
    .item_text {
      display: flex;
      padding: 4px 0;
      .item_icon{
        padding: 0 10px;
        .img{
          width: 24px;
          height: 24px;
        }
      }
      .langtextName {
        width: 100px;
      }
      .showText {
        color: #0099ff;
        margin-left: 14px;
        text-decoration: underline;
        cursor: pointer;
      }
      .item_tag {
        margin-left: 5px;
        margin-bottom: 5px;
      }
      // /deep/ .el-tag.is-hit {
      //   background: none;
      //   border-color: #0286df;
      //   color: #0286df;
      // }
      .item_data {
        // width: calc(100% - 80px);
        margin-left: 5px;
        word-wrap: break-word;
      }
    }
    .item_img {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
    }
    .single_hide {
      // 单行隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .color6 {
      color: #666666;
      font-size: 14px;
      line-height: 24px;
    }
    .color3 {
      color: #333333;
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
    }
  }
  .single_hide {
    // 单行隐藏
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item_text {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
  }
}
</style>
